export default __webpack_public_path__ + "maps-examples-user-location-annotation-thumbnail-960-c0ceb79260eaeb74c7926ff5edc3fcf2.png";